export default __webpack_public_path__ + "static/media/amulets-logo-white.6ac4340b.svg";